/* eslint-disable @typescript-eslint/no-unused-vars */

import { partners } from '@components/home/our-partners'

export const menusWithSubChildren = ['/industries'] as const

export interface SubMenuItem {
  name: string
  slug: string
  id: string
}

export interface SubMenuItemWithChildren {
  name: string
  slug: string
  id: string
  items: SubMenuItem[]
}

export interface MenuItemWithCopy {
  name: string
  slug: '/about' | '/approach' | '/insights' | '/join' // exactly typed to help with NextJS Link route checking
  id: string
  copy: string
}

export interface MenuItemWithSubChildren {
  name: string
  renderTopLevelLink: true
  slug: (typeof menusWithSubChildren)[number] // exactly typed to help with NextJS Link route checking
  id: string
  items: SubMenuItemWithChildren[]
}

interface MenuItemWithChildrenCommon {
  name: string
  id: string
  items: SubMenuItem[]
}
interface MenuItemWithChildrenLinked extends MenuItemWithChildrenCommon {
  renderTopLevelLink: true
  slug: '/services' // exactly typed to help with NextJS Link route checking
}
interface MenuItemWithChildrenUnlinked extends MenuItemWithChildrenCommon {
  renderTopLevelLink: false
  slug: '/partnerships' // exactly typed to help with NextJS Link route checking
}

export type MenuItemWithChildren =
  | MenuItemWithChildrenLinked
  | MenuItemWithChildrenUnlinked

// export interface MenuItemWithChildren {
//   name: string
//   slug: '/services' | '/partnerships' // exactly typed to help with NextJS Link route checking
//   id: string
//   renderTopLevelLink: boolean
//   items: SubMenuItem[]
// }

// type MenuItem =
//   | MenuItemWithCopy
//   | MenuItemWithChildren
//   | MenuItemWithSubChildren

const servicesItems: SubMenuItem[] = [
  {
    name: 'Strategy & Advisory',
    slug: 'strategy-and-advisory',
    id: 'strategy-and-advisory',
  },
  {
    name: 'Data Analytics & Insights',
    slug: 'data-analytics-and-insights',
    id: 'data-analytics-and-insights',
  },
  {
    name: 'Artificial Intelligence',
    slug: 'artificial-intelligence',
    id: 'artificial-intelligence',
  },
  { name: 'Product', slug: 'product', id: 'product' },
  {
    name: 'Data & Application Modernisation',
    slug: 'data-and-app-modernisation',
    id: 'data-and-app-modernisation',
  },
  {
    name: 'Intelligent Platforms',
    slug: 'intelligent-platforms',
    id: 'intelligent-platforms',
  },
]
const services: MenuItemWithChildren = {
  name: 'Services',
  slug: '/services',
  id: 'services',
  renderTopLevelLink: true,
  items: servicesItems,
}

const industriesItems: SubMenuItemWithChildren[] = [
  {
    name: 'Financial Services',
    slug: 'financial-services',
    id: 'financial-services',
    items: [
      { name: 'Banking', slug: 'banking', id: 'banking' },
      { name: 'Insurance', slug: 'insurance', id: 'insurance' },
      {
        name: 'Capital Markets',
        slug: 'capital-markets',
        id: 'capital-markets',
      },
    ],
  },
  {
    name: 'Energy & Utilities',
    slug: 'energy-utilities',
    id: 'energy-utilities',
    items: [
      { name: 'Trading', slug: 'trading', id: 'trading' },
      {
        name: 'Network Operations',
        slug: 'network-operations',
        id: 'network-operations',
      },
      { name: 'Retail', slug: 'retail', id: 'retail' },
    ],
  },
  {
    name: 'Retail',
    slug: 'retail',
    id: 'retail',
    items: [
      { name: 'Product Retail', slug: 'product-retail', id: 'product-retail' },
      {
        name: 'Retail Services',
        slug: 'retail-services',
        id: 'retail-services',
      },
      {
        name: 'Marketing & Merchandising',
        slug: 'marketing-merchandising',
        id: 'marketing-merchandising',
      },
    ],
  },
]
const industries: MenuItemWithSubChildren = {
  name: 'Industries',
  slug: '/industries',
  id: 'industries',
  renderTopLevelLink: true,
  items: industriesItems,
}

const alliancesItems: SubMenuItem[] = [
  { ...partners.databricks, id: partners.databricks.slug },
  { ...partners.snowflake, id: partners.snowflake.slug },
  { ...partners.aws, id: partners.aws.slug },
  { ...partners.google, id: partners.google.slug },
  { ...partners.microsoft, id: partners.microsoft.slug },
]
const alliances: MenuItemWithChildren = {
  name: 'Alliances',
  id: 'alliances',
  slug: '/partnerships',
  renderTopLevelLink: false,
  items: alliancesItems,
}

const about: MenuItemWithCopy = {
  name: 'About',
  slug: '/about',
  id: 'about',
  copy: "We're one of the fastest growing consultancies in APAC",
}
const approach: MenuItemWithCopy = {
  name: 'Approach',
  slug: '/approach',
  id: 'approach',
  copy: 'Find out what makes V2 AI different',
}
const insights: MenuItemWithCopy = {
  name: 'Insights',
  slug: '/insights',
  id: 'insights',
  copy: 'Explore expert Data and AI trends',
}
const join: MenuItemWithCopy = {
  name: 'Join',
  slug: '/join',
  id: 'join',
  copy: 'Ready to make your mark?',
}

export const headerMenu: Array<
  MenuItemWithCopy | MenuItemWithChildren | MenuItemWithSubChildren
> = [about, services, industries, alliances, insights, join]

type MenuItemsArray = Array<
  MenuItemWithCopy | MenuItemWithChildren | MenuItemWithSubChildren
>

export const footerLeft: MenuItemsArray = [about, insights, join, services]
export const footerRight: MenuItemsArray = [industries]

export const menuItemIsWithChildren = (
  item: MenuItemWithCopy | MenuItemWithChildren | MenuItemWithSubChildren,
): item is MenuItemWithChildren | MenuItemWithSubChildren => 'items' in item
